import React, {useContext, useEffect} from 'react';
import {Button} from 'antd';
import DeleteComponent from '../common/DeleteComponent';
import EditComponent from '../common/EditComponent';
import {Arguments} from '../common/Arguments';
import {sideMenuContext} from '../../../router/IndexRouter';
import {GetApiMethod} from '../common/ApiMethod';
import TableComponent from '../common/TablePaginationComponent';

export default function EvaluateInformation(props) {
	const currentUrl = window.location.href;
	const {dataSource, setDataSource, setCopyDataSource} = useContext(sideMenuContext);
	const getApi = Arguments.host + '/society_organization/base/branch/api!evaluateInformation.do';

	useEffect(() => {
		setDataSource([]);
		GetApiMethod({getApi, setDataSource, setCopyDataSource});
	}, [getApi]);

	const columns = [
		{
			title: '序号',
			dataIndex: 'showIndex',
			width: 100,
			sorter: (a, b) => a.showIndex - b.showIndex,
			sortDirections: ['ascend', 'descend'],
		},
		{
			title: '党建考评年度',
			dataIndex: 'year',
			sorter: (a, b) => a.year - b.year,
			sortDirections: ['ascend', 'descend'],
		},
		{
			title: '考评结果',
			dataIndex: 'checkResult',
		},
		{
			title: '操作',
			width: 140,
			render: (item) => (
				<>
					<EditComponent item={item} url={currentUrl}/>
					<DeleteComponent
						item={item}
						postApi={[Arguments.host + '/society_organization/base/branch/api!addEvaluateInformation.do']}
						getApi={getApi}
					/>
				</>
			),
		},
	];

	const indexDataSource = dataSource.map((data, index) => ({showIndex: index + 1, ...data}));

	return (
		<>
			<Button type="primary" onClick={() => props.history.push('/base/evaluate-information/add')}
					style={{marginBottom: 10}}>新增</Button>
			<TableComponent dataSource={indexDataSource} columns={columns}/>
		</>
	);
}



